import React, { useEffect, useState } from 'react';
import {API_TOKEN_NAME, PATIENT_NAME, USER_ID, IMAGE_URL} from '../../../constants';
import {Route} from 'react-router-dom';
import { scAxios, scAxiosAdmin } from '../../..';
import { LineChart, PieChart } from 'react-chartkick';
import 'chart.js';
const getAllPatientHealthChartData = (data) => {
  return new Promise((resolve, reject) => {
    const req = scAxios.request('/vitalspatient', {
      method: 'get',
      headers: {
          'Accept': 'application/json',
      },
      params: {
        ...data
      }
    });
    req.then(res => resolve(res.data))
        .catch(err => reject(err));
  });
}
export default function SecondTab(){
  const [patienthealthchart, setPatientHealthChart] = useState([]);
  const refreshgetAllPatientHealthChartData = () => {
    const data = {
      xpatient: localStorage.getItem(USER_ID),
    }
    getAllPatientHealthChartData(data)
    .then(res => {
        const result = res.map(({Hight,...rest}) => ({...rest}));
        var inputs  = result.map(function(result_data){
          return {
            [result_data.Date]: result_data.Weight,
          };
        })
        let output = {};
        for (let i = 0; i < inputs.length; i++) {
          const d = inputs[i];
          for (const key in d) {
            output[key] = d[key];
          }
        }
        setPatientHealthChart(output);
        /*this.setState({ patienthealthchartdate: res.Date });
        this.setState({ patienthealthchartweight: res.Weight });*/
    })
    .catch(err => {
        console.log(err);
    });
  }
  useEffect(() => {
    refreshgetAllPatientHealthChartData();
  }, []);
  return (
    <div className="SecondTab mt-3">
      <LineChart data={patienthealthchart} />
    </div>
  );
};


// WEBPACK FOOTER //
// ./src/component/dashboard/AllTabs/SecondTab.js